export enum REQUEST_STATUS {
    AWAITING = 'awaiting',
    ACCEPTED = 'approved',
    REJECTED = 'rejected',
    CLOSED = 'closed'
};

export enum COURSE_CHANGE_TAB {
    ADDED,
    REMOVED,
    REORDERED,
    OTHER_CHANGES,
    ADVANCE_SETTINGS,
    DATE_CHANGE,
};

export enum COURSE_CHANGE_CONFIMATION_POPUP {
    REORDERED,
    DATE_CHANGE,
};